import { html, nothing } from 'lit';
import type { TefComs4csMicroFrontend } from '@src/components/tef-coms4cs';

export function buttonsTemplate(this: TefComs4csMicroFrontend) {
  if (this.mode === 'buttons' && !this.store.identity?.readonly) {
    return html`
      <div class="section section-buttons">
        <button
          class="button button-default"
          .disabled=${!(this.store.touched && this.store.hasModifiedFromOriginal)}
          @click=${async () => { await this.store.save(); }}>
          Speichern
        </button>
      </div>`;
  }

  if (this.mode === 'buttons:undoAll' && this.store.touched && this.store.hasModifiedFromOriginal) {
    return html`
      <div class="container">
        <div class="row justify-content-end">
            <button
              class="button button-default"
              @click=${() => { this.store.undoAll(); }}>
              Änderungen widerrufen
            </button>
        </div>
      </div>`;
  }

  return html`${nothing}`;
}
